
// import { pp, pp_user, app_state, notify } from '@helpers'

import { appStore } from "@stores";

export const useBusinessStore = {

    state: ()/* : State */ => ({

        form: {},

    }),

    getters: {

        // getXXX(){
        //     return (status) => {
        //         return
        //     }
        // },
    },

    actions: {

        setBusiness(business){
            if( ! business){ business = {} } // for Create

            business = {
                // ...business,

                id:             business.id             ?? null,
                label:          business.label          ?? '',
                // shops_ids:      business.shops_ids      ?? [],
                email:          business.email          ?? null,
                contact:        business.contact        ?? '',
                address:        business.address        ?? '',
                description:    business.description    ?? '',
                phone:          business.phone          ?? '',
            }

            return business
        },


        // for Edit and Create
        initForm(business){

            business = this.setBusiness(business)

            this.form = proto.$inertia.form(business)

            // log('in stores/business @initForm()',this.form)
        },

        // for Edit (in Index) and Create
        submit(){

            var router = this.form.id ? route('business.update', this.form.id) : route('business.store')

            // const formDatas = this.form.data()

            this.form
                // .transform(data => ({
                //     ...data,
                // }))
                [this.form.id ? 'put' : 'post'](router, {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.form.reset();

                        appStore().getAllUsers(true)
                    },
                });
        },

    }
}
